import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { WatchlistModel } from '../api/models';
import { TeamService, WatchlistService } from '../api/services';

@Injectable({ providedIn: 'root' })
export class PlayerPopoverService {
  private _wishlists$ = new ReplaySubject<WatchlistModel[]>();
  private _evanmiyaTeams$ = new ReplaySubject<string[]>();
  private _realGMTeams$ = new ReplaySubject<string[]>();
  private _statheadTeams$ = new ReplaySubject<string[]>();

  public wishlists$ = this._wishlists$.asObservable();
  public evanmiyaTeams$ = this._evanmiyaTeams$.asObservable();
  public realGMTeams$ = this._realGMTeams$.asObservable();
  public statheadTeams$ = this._statheadTeams$.asObservable();

  constructor(
    private watchlistService: WatchlistService,
    private teamService: TeamService
  ) {
    this.reset();
  }

  reset() {
    this.watchlistService.apiWatchlistGet$Json().subscribe({
      next: ({ data }) => {
        this._wishlists$.next(data || []);
      }
    });

    this.teamService.apiTeamTeamsEvanmiyaGet$Json().subscribe({
      next: ({ data }) => {
        this._evanmiyaTeams$.next(data || []);
      }
    });

    this.teamService.apiTeamTeamsRealgmGet$Json().subscribe({
      next: ({ data }) => {
        this._realGMTeams$.next(data || []);
      }
    });

    this.teamService.apiTeamTeamsStatheadGet$Json().subscribe({
      next: ({ data }) => {
        this._statheadTeams$.next(data || []);
      }
    });
  }
}